/**
 * Perfil de sessão para indicador visual (master vs portal revenda).
 * Espelha a lógica usada em RequireMasterPlatform / faixa superior.
 */
export function getSessionRoleIndicator(userData) {
  if (!userData || typeof userData !== "object") return null;
  if (userData.scope === "partner") {
    return {
      key: "partner",
      tooltip: "Portal de revenda — conta parceira.",
      /** Roxo bem visível (alinha faixa superior + contorno do avatar). */
      accent: "#9c27b0",
    };
  }
  if (userData.scope === "platform" || Number(userData.master) === 1) {
    const platform = userData.scope === "platform";
    return {
      key: "master",
      tooltip: platform
        ? "Console da plataforma — usuário administrativo."
        : "Usuário master deste workspace.",
      /** Azul vivo para contraste no claro/escuro. */
      accent: "#1e88e5",
    };
  }
  return null;
}
